import { makeStyles } from "@fluentui/react-components";

export const usePlaybookViewerStyles = makeStyles({
  container: {
    marginTop: "1.5rem",
  },
  cards: {
    marginTop: "1rem",
  },
});
